import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Camera } from '@ionic-native/camera';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
//import { Device } from '@ionic-native/device';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { Items } from '../mocks/providers/items';
import { Settings, User, Api } from '../providers';
import { MyApp } from './app.component';
import { AuthProvider } from '../providers/auth/auth';
import { environment } from '../environments/environment';

import { Shop } from './app.shop';

import { Sloader } from '../providers/common/sloader';

import { SharedModule } from './shared.module';
import { CacheModule } from "ionic-cache";

import { SuperTabsModule } from 'ionic2-super-tabs';
import { PopoverpageComponent } from '../components/popoverpage/popoverpage';
import { CartProvider } from '../providers/cart/cart';
import { OneSignal } from '@ionic-native/onesignal';
import { Badge } from '@ionic-native/badge';
import { Network } from '@ionic-native/network'
import { AlertProvider } from '../providers/alert/alert';
import { NetworkProvider } from '../providers/network/network';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CallNumber } from '@ionic-native/call-number';
import { LogProvider } from '../providers/log/log';
import { ViewedproductProvider } from '../providers/viewedproduct/viewedproduct';
import { IonicImageLoader } from 'ionic-image-loader';
//import { SpeechRecognition } from '@ionic-native/speech-recognition';
import { NativePageTransitions } from '@ionic-native/native-page-transitions';
import { IonicImageViewerModule, ImageViewerController } from 'ionic-img-viewer';
import { DatePipe } from '@angular/common';
import { Deeplinks } from '@ionic-native/deeplinks';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SiteinfoProvider } from '../providers/siteinfo/siteinfo';
import { DatePickerModule } from 'ion-datepicker';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
import { QRCodeModule } from 'angularx-qrcode';
import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { ReplacePipe } from '../libs/replace-pipe';
import { PhonePipe } from '../libs/phone';
// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function provideSettings(storage: Storage) {
    /**
     * The Settings provider takes a set of default settings for your app.
     *
     * You can add new settings options at any time. Once the settings are saved,
     * these values will not overwrite the saved values (this can be done manually if desired).
     */
    return new Settings(storage, {
        option1: true,
        option2: 'Ionitron J. Framework',
        option3: '3',
        option4: 'Hello'
    });
}
export function jwtOptionsFactory(storage) {
    return {
        tokenGetter: () => {
            return storage.get(environment.access_token).then((val) => {
                return val;
            });
        },
        whitelistedDomains: [environment.api]
    }
}

@NgModule({
    declarations: [
        MyApp,
        // ReplacePipe,
        // PhonePipe,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        IonicModule.forRoot(MyApp, {
            statusbarPadding: true,
            platforms: {
                android: {
                    statusbarPadding: true,
                    tabsHideOnSubPages: true
                },
                ios: {
                    statusbarPadding: true,
                    tabsHideOnSubPages: true
                }
            },
            monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
            monthShortNames: ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9', 'T10', 'T11', 'T12'],
            dayNames: ['Chủ nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
            dayShortNames: ['Chủ nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
        }),
        DatePickerModule,
        // PdfViewerModule,
        IonicStorageModule.forRoot(
            {
                name: '__vesapa',
            }
        ),
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: jwtOptionsFactory,
                deps: [Storage],
            }
        }),
        SharedModule,
        SuperTabsModule.forRoot(),
        IonicImageLoader.forRoot(),
        CacheModule.forRoot({ keyPrefix: 'bca_' }),
        IonicImageViewerModule,
        QRCodeModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        PopoverpageComponent,
    ],
    providers: [
        Api,
        AuthProvider,
        Items,
        User,
        Camera,
        SplashScreen,
        StatusBar,
        NativePageTransitions,
        ImageViewerController,
        { provide: Settings, useFactory: provideSettings, deps: [Storage] },
        // Keep this to enable Ionic's runtime error handling during development
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        Shop,

        Sloader,
        CartProvider,
        //Device,
        CartProvider,
        OneSignal,
        Badge,
        Network,
        AlertProvider,
        NetworkProvider,
        CallNumber,
        LogProvider,
        //SpeechRecognition,
        ViewedproductProvider,
        Deeplinks,
        InAppBrowser,
        DatePipe,
        SiteinfoProvider
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts